import {Yii} from "libraries/interfaces/Yii";
import { ILabels } from "../../../../interfaces/ILabels";

export const yii: ILabels = {
    offersAndDetails: Yii.t('wui-shared-js', 'Offres & Détails'),
    chooseQuotation: Yii.t('wui-shared-js', 'Choisir'),
    hotelsFoundTitle: Yii.t('wui-shared-js', 'hotels correspondant à votre recherche'),
    showList : Yii.t('wui-shared-js', 'Voir la liste'),
    mapFullscreen: Yii.t('wui-shared-js', 'Agrandir la carte'),
    mapReduce: Yii.t('wui-shared-js', 'Réduire la carte'),
    selectAnHotel: Yii.t('wui-shared-js', 'Sélectionner un hôtel en cliquant sur un marqueur'),
    zoomIn: Yii.t('wui-shared-js', 'Zoomer'),
    zoomOut: Yii.t('wui-shared-js', 'Dézoomer'),
    hotelsLoading: Yii.t('wui-shared-js', 'Chargement des hotels en cours ...'),
    generateQuotation: Yii.t('wui-shared-js', 'Génération de la cotation en cours ...'),
    searchMapPlaceholder: Yii.t('wui-shared-js', 'Rechercher'),
};
